import axios, { AxiosInstance } from 'axios';
import { IStorageProvider } from '../storage/IStorageProvider';
import { DefaultStorageProvider } from '../storage/DefaultStorageProvider';
import { CoreInterceptors } from './interceptors';

export interface ApiClientConfig {
  clientId: string;
  resourceApiBaseUrl: string;
  idpBaseUrl: string;
  proxyBaseUrl?: string;
  storage?: IStorageProvider;
  errorHandler?: (err: any) => void;
  withCredentials?: boolean;
}

export class ApiClient {
  public readonly axiosInstance: AxiosInstance;
  public readonly oAuth2AxiosInstance: AxiosInstance;
  public readonly storage: IStorageProvider;
  public readonly config: ApiClientConfig;
  private interceptors: CoreInterceptors;

  constructor(config: ApiClientConfig, refreshTokenCallback: () => Promise<string>) {
    this.config = {
      ...config,
    };
    this.storage = this.config.storage || new DefaultStorageProvider();

    this.axiosInstance = axios.create({
      baseURL: this.config.resourceApiBaseUrl,
      withCredentials: this.config.withCredentials || false,
    });

    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    this.oAuth2AxiosInstance = axios.create({
      baseURL: this.config.proxyBaseUrl || `${origin}/api`,
      withCredentials: true,
    });

    this.interceptors = new CoreInterceptors(this.storage, refreshTokenCallback, this.config.errorHandler);
    this.interceptors.attach(this.axiosInstance);
  }
}
